// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"429":"71b9613e","455":"a4d841e6","578":"6c833b1d","774":"85d4e245","946":"65568695"}[chunkId] + ".chunk.js";
};